import { createTheme } from "@mui/material";

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 800,
      lg: 1200,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: "Poppins, sans-serif",

    fontSize: 14,
    body1: {
      fontStyle: "normal",
      color: "rgba(255, 255, 255, 0.71)",
      fontSize: "1.125rem",
      fontWeight: 400,
      lineHeight: "25.2px",
    },
    body2: {
      fontStyle: "normal",
      color: "rgba(255, 255, 255, 0.71)",
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.57,
    },
    subtitle1: {
      fontStyle: "normal",
      color: "rgba(255, 255, 255, 0.71)",
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: 1.75,
    },
    subtitle2: {
      fontStyle: "normal",
      color: "rgba(255, 255, 255, 0.71)",
      fontSize: "0.875rem",
      fontWeight: 500,
      lineHeight: 1.57,
    },
    overline: {
      fontSize: "0.75rem",
      fontWeight: 600,
      letterSpacing: "0.5px",
      lineHeight: 2.5,
      textTransform: "uppercase",
    },
    caption: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: 1.66,
    },
    h1: {
      color: "#FFFFFF",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "4rem",
      lineHeight: "80px",
      letterSpacing: " -3.84px",
    },
    h2: {
      color: "#FFFFFF",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "2.5rem",
      lineHeight: "64px",
    },
    h3: {
      color: "#FFFFFF",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "2.25rem",
      lineHeight: "39.2px",
      letterSpacing: " -2.4px",
    },
    h4: {
      color: "#FFFFFF",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "2.25rem",
      lineHeight: "39.2px",
      letterSpacing: " -2.4px",
    },
    h5: {
      color: "#FFFFFF",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: "30px",
      letterSpacing: " -1.4px",
    },
    h6: {
      color: "#FFFFFF",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "1.125rem",
      lineHeight: "20px",
      letterSpacing: " -0.8px",
    },
  },
  palette: {
    primary: {
      main: "#FF134E",
      // main: "#24e361",
      light: "#FE144E",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, 0.71)",
    },
    background: {
      default: "#000",
    },
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          color: "#FFFFFF",
          backgroundColor: "#111111",
          borderRadius: "8px",
        },
        icon: {
          color: "#FFFFFF",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          color: "#FFFFFF",
          borderRadius: "8px",
          backgroundColor: "#111111",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "rgb(255, 19, 78)",
            color: "#FFFFFF",
          },
          "&.Mui-selected": {
            backgroundColor: "rgb(255, 19, 78) !important",
            color: "#FFFFFF",
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "Poppins, sans-serif", // Apply font family globally

          margin: 0,
          padding: 0,
          backgroundColor: "#000", // Optional: Default background color
          color: "#FFF", // Optional: Default text color
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: "#FFFFFF",
          backgroundColor: "#111111",
          borderRadius: "8px",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#FF134E",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#FF134E",
          },
        },
        notchedOutline: {
          borderColor: "#FFFFFF",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Poppins",
          fontWeight: "700",
          fontSize: "16px",
          fontStyle: "normal",
          lineHeight: "24px",
          color: "#FFFFFF",
          padding: "15px 30px",
          backgroundColor: "#515151",
          width: "fit-content",
          height: "54px",
          borderRadius: "15px",
          textTransform: "capitalize",
          whiteSpace: "nowrap",
          boxShadow: "5px 5px 50px 0px rgba(0, 21, 42, 0.18)",
          backdropFilter: "blur(25px)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          },
        },
      },
    },
  },
});
